import RuntimeException from '../../../../java/lang/RuntimeException'

export default class AssertionFailedException extends RuntimeException { }
